import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { pick, path } from 'ramda';

import { saveBackUrl } from 'actions/userActions';
import { main, requestMetro, requestMetroApproval, profile } from 'constants/routes';

@connect(pick(['backUrl']), { saveBackUrl })
export class UserRedirect extends Component {
    componentDidMount() {
        this.props.saveBackUrl('');
    }

    getDefaultRoute(permissions) {
        if (path(['employee', 'metroRequest'], permissions)) {
            return requestMetro.stringify();
        }

        if (path(['employee', 'metroApproval'], permissions)) {
            return requestMetroApproval.stringify();
        }

        if (path(['web'], permissions)) {
            return main.path;
        }

        return profile.stringify();
    }

    render() {
        const { backUrl, permissions, location } = this.props;
        const redirect = backUrl || this.getDefaultRoute(permissions);

        return location.pathname === redirect ? null : <Redirect to={redirect} />;
    }
}

export default function UserRoute({ permission, component, ...props }) {
    const redirect = () => <Redirect to='/unknown' />;
    const Component = permission ? component : redirect;

    return <Route {...props} permission={permission} component={Component} />;
}
